'use client'

import { useSidebar } from '~/components/ContentLayoutClient'
import HeaderSidebarToggleButton from '~/components/HeaderSidebarToggleButton'

export default function ContentSidebarToggleButton() {
  const { isMobileOpen, setMobileOpen } = useSidebar()

  return (
    <HeaderSidebarToggleButton
      isOpen={isMobileOpen}
      onToggle={() => setMobileOpen(!isMobileOpen)}
    />
  )
}
